import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cce283a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1cce283a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cce283a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cce283a')) {
      api.createRecord('1cce283a', component.options)
    } else {
      api.reload('1cce283a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cce283a&scoped=true", function () {
      api.rerender('1cce283a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/storeCard/index.vue"
export default component.exports